@if (theme() === "modern-neue" || theme() === "gradient") {
  <div class="ntt-featured-icon__inner">
    <span [class]="'ntt-featured-icon__icon ' + icon()"></span>
  </div>
} @else {
  <span [class]="'ntt-featured-icon__icon ' + icon()"></span>
}
